import { buildGoalsTimelineFilterDocument } from '@griply/utils';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useGoalsTimelineFilterDocument = () => {
  const user = useUser();
  return useMemo(
    () => buildGoalsTimelineFilterDocument(user?.settings),
    [user?.settings],
  );
};
